import React from "react";
import { Container, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { SlotFilters } from "./SlotFilters/SlotFilters";
import { SlotsSection } from "./SlotsSection/slotsSection";
import { PaymentSection } from "../PaymentsSection/payment.section";
import { ProvidersSection } from "../ProvidersSection/providers.section";
import "./Slots.css";
import all from "../../assets/icons/menu/all.svg";
import popular from "../../assets/icons/menu/popular.svg";
import bell from "../../assets/icons/menu/bell.svg";
import recommended from "../../assets/icons/menu/recommended.svg";
import slots from "../../assets/icons/menu/slots.svg";
import live from "../../assets/icons/menu/live_casino.svg";
import crash_games from "../../assets/icons/menu/rocket.svg";
import roulette from "../../assets/icons/menu/roulette.svg";
import card_games from "../../assets/icons/menu/card_games.svg";
import megaways from "../../assets/icons/menu/mega_ways.svg";
import jackpots from "../../assets/icons/menu/jackpots.svg";
import bonus_buy from "../../assets/icons/menu/buy_bonus.svg";
import TopWins from "../TopWins/TopWins";
import { slotsQueryObjectHelper } from "../../utils/slotsQueryObjectHelper";
import { slotsAttributeHelper } from "../../utils/slotsAttributeHelper";
import { CategoriesSection } from "./CategoriesSection/CategoriesSection";

const filters = [
  {
    name: "all",
    image: all,
    path: "/lobby/slots?all=true",
  },
  {
    name: "popular",
    image: popular,
    path: "/lobby/slots?popular=true",
  },
  {
    name: "new",
    image: bell,
    path: "/lobby/slots?new=true",
  },
  {
    name: "recommended",
    image: recommended,
    path: "/lobby/slots?recommended=true",
  },
  {
    name: "jackpots",
    image: jackpots,
    path: "/lobby/slots?category=jackpots",
  },
  {
    name: "buy_fs",
    image: bonus_buy,
    path: "/lobby/slots?buy_fs=true",
  },
  {
    name: "slots",
    image: slots,
    path: "/lobby/slots",
  },
  {
    name: "live",
    image: live,
    path: "/lobby/live",
  },
  {
    name: "crash_games",
    image: crash_games,
    path: "/lobby/crash",
  },
  {
    name: "roulette",
    image: roulette,
    path: "/lobby/live?category=roulette",
  },
  {
    name: "card_games",
    image: card_games,
    path: "/lobby/live?category=card_games",
  },
  {
    name: "mega_ways",
    image: megaways,
    path: "/lobby/slots?category=megaways",
  },
];
export const Slots = () => {
  const navigator = useNavigate();
  const providerChangeHandler = (providerId: number) => {
    if (providerId === 80 || providerId === 79) {
      navigator(`/lobby/live?provider=${providerId}`);
      return;
    }
    if (providerId === 82) {
      navigator(`/lobby/crash?provider=${providerId}`);
      return;
    }
    navigator(`/lobby/slots?provider=${providerId}`);
  };
  return (
    <Box className="slots">
      <Container className="container" maxWidth={false} disableGutters>
        <SlotFilters
          isMain={true}
          section="main"
          filters={filters}
          providerChangeHandler={providerChangeHandler}
        />
        <SlotsSection
          action="popular"
          object={slotsQueryObjectHelper("popular")}
          attribute={slotsAttributeHelper(slotsQueryObjectHelper("popular"))}
          src={popular}
          path="/lobby/slots?popular=true"
        />
        <SlotsSection
          action="new"
          src={bell}
          object={slotsQueryObjectHelper("new")}
          attribute={slotsAttributeHelper(slotsQueryObjectHelper("new"))}
          path="/lobby/slots?new=true"
        />
        <CategoriesSection />
        <SlotsSection
          action="recommended"
          src={recommended}
          object={slotsQueryObjectHelper("recommended")}
          attribute={slotsAttributeHelper(
            slotsQueryObjectHelper("recommended")
          )}
          path="/lobby/slots?recommended=true"
        />
        <PaymentSection />
        <SlotsSection
          action="slots"
          src={slots}
          object={slotsQueryObjectHelper("slots")}
          attribute={slotsAttributeHelper(slotsQueryObjectHelper("slots"))}
          path="/lobby/slots"
        />
        <SlotsSection
          action="live"
          object={slotsQueryObjectHelper("live")}
          attribute={slotsAttributeHelper(slotsQueryObjectHelper("live"))}
          src={live}
          path="/lobby/live"
        />
        <TopWins />
        <ProvidersSection />
        <SlotsSection
          action="crash_games"
          src={crash_games}
          object={slotsQueryObjectHelper("crash_games")}
          attribute={slotsAttributeHelper(
            slotsQueryObjectHelper("crash_games")
          )}
          path="/lobby/crash"
        />
        <SlotsSection
          action="roulette"
          src={roulette}
          object={slotsQueryObjectHelper("roulette")}
          attribute={slotsAttributeHelper(slotsQueryObjectHelper("roulette"))}
          path="/lobby/live?category=roulette"
        />
        <SlotsSection
          action="card_games"
          src={card_games}
          object={slotsQueryObjectHelper("card_games")}
          attribute={slotsAttributeHelper(slotsQueryObjectHelper("card_games"))}
          path="/lobby/live?card_games=true"
        />
        <SlotsSection
          action="mega_ways"
          src={megaways}
          object={slotsQueryObjectHelper("mega_ways")}
          attribute={slotsAttributeHelper(slotsQueryObjectHelper("mega_ways"))}
          path="/lobby/slots?mega_ways=true"
        />
        <SlotsSection
          action="jackpots"
          src={jackpots}
          object={slotsQueryObjectHelper("jackpots")}
          attribute={slotsAttributeHelper(slotsQueryObjectHelper("jackpots"))}
          path="/lobby/slots?category=jackpots"
        />
        <SlotsSection
          action="bonus_buy"
          src={bonus_buy}
          object={slotsQueryObjectHelper("bonus_buy")}
          attribute={slotsAttributeHelper(slotsQueryObjectHelper("bonus_buy"))}
          path="/lobby/slots?bonus_buy=true"
        />
      </Container>
    </Box>
  );
};
